module.exports = __webpack_public_path__ + "img/car.6b60faf4.png";